import { Theme } from '@shared/services/theme/theme';
import { HeaderKey } from 'src/config/api-endpoints';
import { CJX_API_ENDPOINT } from 'src/config/cjx/api-endpoints';
import { updateHeaders } from 'src/config/update-headers';
import env from 'src/environments/.env';
import { environment as defaultEnv } from 'src/environments/base.environment';

let environment = {
  ...defaultEnv,
  assetPath: '/assets/images/cjx',
  version: env.version + '-cjx-develop',
  theme: Theme.CJX,
  tier: 'develop',
  blockSales: false,
  supplierName: 'CJX',
  prefixCompany: 'CJX',
  companyTH: 'ซีเจเอ็กซ์',
  copyRight: '2025 TD TAWANDANG CO.,LTD. All RIGHTS RESERVED. TDTECH.APP',
  merchantCompanyTax: '0105566204723',
  imgLogo: '/assets/images/cjx/cjx-logo.svg',
  imgLogoVertical: '/assets/images/cjx/vertical-logo-border.png',
  serverUrl: 'https://api.dev-cjx.tdtech.app',
  serverPosUrl: 'https://api.dev-cjx.tdtech.app',
  storeResourcesPath: '/store-resources-green', //todo fix
  imgUrl: 'https://storage.googleapis.com/tdtech-dev-cjx-app-nest-product-assortments',
  favicon: 'favicon-cj',
  reportXHost: 'report.api.tdtech.app',
  cookies: {
    ...defaultEnv.cookies,
    domain: env.forceDomain || 'nest.dev-cjx.tdtech.app'
  },
  viewStore: {
    isShowHandDevice: true,
    isShowBuddyDevice: true,
    isShowAddPosDevice: true
  },
  importStoreGroupLimit: 3000,
  setting: {
    configs: {
      saleSchedule: {
        ...defaultEnv.setting.configs.saleSchedule,
        blockTimes: {
          from: '12:00',
          to: '13:00'
        }
      },
      refillStockSchedule: {
        blockTimes: {
          from: '12:00',
          to: '13:00'
        }
      },
      pettyCashEventBased: {
        blockTimes: {
          from: '12:00',
          to: '13:00'
        }
      },
      pettyCashDefault: {
        blockTimes: {
          from: '12:00',
          to: '13:00'
        }
      },
      singleLocationStockFrontStoreOnly: {
        blockTimes: {
          from: '12:00',
          to: '13:00'
        }
      },
      refillPriority: {
        blockTimes: {
          from: '12:00',
          to: '13:00'
        }
      },
      storePickingUnit: {
        blockTimes: {
          from: '12:00',
          to: '13:00'
        }
      },
      storeExpenseLimit: {
        blockTimes: {
          from: '12:00',
          to: '13:00'
        }
      },
      onlineProductCategoryOwnDelivery: {
        blockTimes: {
          from: '12:00',
          to: '13:00'
        }
      }
    }
  }
};

export const X_HOST_HEADER = {
  [HeaderKey.Pim]: {
    'x-host': 'pim.api.tdtech.app'
  },
  [HeaderKey.Authorization]: {
    Authorization: 'Basic QURNSU5fUE9SVEFMOlBAc3N3MHJk',
    'x-host': 'oauth.api.tdtech.app'
  },
  [HeaderKey.Billing]: {
    'x-host': 'billing.api.tdtech.app'
  },
  [HeaderKey.DataInsight]: {
    'x-host': 'data-insight.api.tdtech.app'
  },
  [HeaderKey.Dashboard]: {
    'x-host': 'dashboard.api.tdtech.app'
  },
  [HeaderKey.Identity]: {
    'x-host': 'identity.api.tdtech.app'
  },
  [HeaderKey.Master]: {
    'x-host': 'master.api.tdtech.app'
  },
  [HeaderKey.Merchant]: {
    'x-host': 'merchant.api.tdtech.app'
  },
  [HeaderKey.Marketing]: {
    'x-host': 'marketing.api.tdtech.app'
  },
  [HeaderKey.Membership]: {
    'x-host': 'membership.api.tdtech.app'
  },
  [HeaderKey.NestExporter]: {
    'x-host': 'nest-exporter.api.tdtech.app'
  },
  [HeaderKey.NestMaster]: {
    'x-host': 'nest.master.api.tdtech.app'
  },
  [HeaderKey.Pos]: {
    'x-host': 'pos.api.tdtech.app'
  },
  [HeaderKey.Product]: {
    'x-host': 'product.api.tdtech.app'
  },
  [HeaderKey.Purchase]: {
    'x-host': 'purchase.api.tdtech.app'
  },
  [HeaderKey.Stock]: {
    'x-host': 'stock.api.tdtech.app'
  },
  [HeaderKey.Store]: {
    'x-host': 'store.api.tdtech.app'
  },
  [HeaderKey.Supplier]: {
    'x-host': 'supplier.api.tdtech.app'
  },
  [HeaderKey.Settlement]: {
    'x-host': 'settlement.api.tdtech.app'
  },
  [HeaderKey.Report]: {
    'x-host': 'report.api.tdtech.app'
  },
  [HeaderKey.Tote]: {
    'x-host': 'tote.api.tdtech.app'
  },
  [HeaderKey.Order]: {
    'x-host': 'order.api.tdtech.app'
  },
  [HeaderKey.Workflow]: {
    'x-host': 'workflow.api.tdtech.app'
  }
};

const apiEndpoint = updateHeaders(CJX_API_ENDPOINT, X_HOST_HEADER);
environment.services = {
  ...apiEndpoint,
  productAssortment: {
    ...apiEndpoint.productAssortment,
    bucketName: '/tdtech-dev-cjx-app-nest-product-assortments'
  },
  advertisements: {
    ...apiEndpoint.advertisements,
    bucketName: '/tdtech-dev-cjx-app-nest-pos-ads'
  }
};

export { environment };
